const EventoActionTypes = {
    ACAO_EVENTO: "acao/evento",
}

export default EventoActionTypes;